<template>
  <div class="box">
    <ul class="pcelist">
      <li :key="index" v-for="(item,index) in eList">
        <router-link :to="{path:'estateDetail?estateId='+item.pkId}">
          <img v-lazy="item.path+'&type=1&size=240x180'" />
          <p class="eititle">{{item.name}}<span class="etype" v-if="item.estateTypeName">{{item.estateTypeName}}</span></p>
          <span class="mprice no" v-if="item.price==null||item.price==0"><b>售价待定</b></span>
          <span class="mprice" v-else><b>{{item.price}}</b>{{item.priceUnit}}</span>
          <slot v-if="$store.state.domainIndex==1"> 
            <p class="p-normal"><i class="m-icon mi-jzmj"></i><span>建筑面积：</span>{{item.area?item.area + "㎡":'暂无资料'}}</p>
            <p class="p-normal"><i class="m-icon mi-lpdz"></i><span>楼盘地址：</span>{{item.stName}}-{{item.scName}}</p>
            <p class="mtag" v-if="item.taglist">
               <span >{{item.saleStatusName}}</span>
              <span :key="i" v-for="(o,i) in item.tagList" >{{o.name}}</span>
            </p>
            <p class="mtag" v-else>
               <span >{{item.saleStatusName}}</span>
            </p>
          </slot>
          <slot v-if="$store.state.domainIndex==2">
            <p class="p-normal"><span>楼盘地址：</span>{{item.stName}}-{{item.scName}}</p>
            <p class="p-normal"><span>建筑面积：</span>{{item.area?item.area + "㎡":'暂无资料'}}</p>
            <p class="mtag" v-if="item.tagList">
               <span >{{item.saleStatusName}}</span>
              <span :key="i" v-for="(o,i) in item.tagList" >{{o.name}}</span>
            </p>
           <p class="mtag" v-else>
               <span >{{item.saleStatusName}}</span>
            </p>

          </slot>
          <p class="eitel"><i class="m-icon mi-tel"></i>{{item.phone2}}</p>
        </router-link>
      </li>
    </ul>
    <div class="recomlist" v-if="isRecom">
      <p class="rtitle">为你推荐热销楼盘</p>
      <ul>
        <li :key="index" v-for="(item,index) in recomItems">
          <router-link :to="{path:'estateDetail?estateId='+item.pkId}">
            <img v-lazy="item.path+'&type=1&size=240x180'" />
            <p class="eititle">{{item.name}}</p>
            <span class="mprice no" v-if="item.price==null||item.price==0"><b>售价待定</b></span>
            <span class="mprice" v-else><b>{{item.price}}</b>{{item.priceUnit}}</span>
            <p class="p-normal"><span>楼盘地址：</span>{{item.stName}}-{{item.scName}}</p>
            <p class="p-normal"><span>建筑面积：</span>{{item.acreage?item.acreage:'暂无资料'}}</p>
            <p class="p-normal"><span>优势：</span>{{item.advantage?item.advantage:'暂无资料'}}</p>
            <p class="mtag" v-if="item.tagList">
             
              <span :key="i" v-for="(o,i) in item.tagList" >{{o.name}}</span>
            </p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props:{
    isPC:Boolean,
    eList:Array,
    isRecom:Boolean
  },
  data () {
    return {
      recomItems:[],
    }
  },
  mounted(){
    var _this = this;
    if(_this.isRecom){
      _this.getRecom();
    }
  },
  methods:{
    getRecom:function(){
      this.$http.get('/api/baidu/getHotEstateList').then((response)=>{
        this.recomItems = response.data.result
      }).catch((response)=>{
        console.log(response)
      })
    }
  }
}
</script>

<style scoped>
li{padding-left:260px;position:relative;height:180px;margin-bottom:25px;padding-right:140px;line-height:20px;}
li img{width:240px;height:100%;position:absolute;left:0;top:0;}
.eititle{font-size:20px;line-height:36px;}
.mprice{position:absolute;right:0;top:0;}
.mprice b{font-size:24px;}
.mprice.no b{font-style:normal;margin-right:0;font-size:20px;}
.p-normal{margin-top:9px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.p-normal span{color:#999;}
.mtag{margin-top:11px;height:32px;overflow:hidden;}
.eitel{font-weight:700;font-size:20px;color:#dcad1a;margin-top:11px;line-height:30px;}
.mi-tel{width:30px;height:30px;background-position:0 -64px;position:relative;margin-right:10px;float:left;background-size:184px;}
.recomlist{margin-top:20px;}
.recomlist li{height:160px;}
.rtitle{font-size:24px;line-height:30px;margin-bottom:25px;}
</style>



// WEBPACK FOOTER //
// src/components/public/PCEstateList.vue